// Pick-lists for the health-history fields. ปฏิเสธ is not listed here:
// HealthListInput always offers it first. Starter lists, pending clinic approval.

export const DISEASE_OPTIONS = [
  "ความดันโลหิตสูง",
  "เบาหวาน",
  "ไขมันในเลือดสูง",
  "โรคหัวใจ",
  "โรคหลอดเลือดสมอง",
  "โรคหอบหืด",
  "โรคปอด/COPD",
  "โรคไต",
  "โรคตับ/ไวรัสตับอักเสบ",
  "โรคไทรอยด์",
  "โรคเลือด/เลือดออกง่าย",
  "โรคลมชัก",
  "โรคกระดูกพรุน",
  "มะเร็ง (กำลังรักษา/ฉายแสง)",
  "HIV",
  "ภูมิแพ้",
  "โรคทางจิตเวช",
];

export const ALLERGY_OPTIONS = [
  "Penicillin (เพนิซิลลิน)",
  "Amoxicillin (อะม็อกซีซิลลิน)",
  "Sulfa (ซัลฟา)",
  "NSAIDs (ยาต้านอักเสบ)",
  "Aspirin (แอสไพริน)",
  "Ibuprofen (ไอบูโพรเฟน)",
  "ยาชาเฉพาะที่ (Local anesthetic)",
  "Lidocaine (ลิโดเคน)",
  "Codeine (โคเดอีน)",
  "Erythromycin (อีริโทรมัยซิน)",
  "Tetracycline (เตตราซัยคลิน)",
  "Metronidazole (เมโทรนิดาโซล)",
  "Latex (ยางธรรมชาติ)",
  "ไอโอดีน",
  "อาหารทะเล",
];

export const MEDICATION_OPTIONS = [
  // ยาต้านการแข็งตัวของเลือด (Anticoagulants/Antiplatelets)
  "Aspirin (แอสไพริน)",
  "Warfarin (วาร์ฟาริน)",
  "Clopidogrel (โคลพิโดเกรล)",
  "Heparin (เฮปาริน)",
  "Rivaroxaban (ริวารอกซาบัน)",
  // ยาเบาหวาน (Diabetes medications)
  "Metformin (เมตฟอร์มิน)",
  "Insulin (อินซูลิน)",
  "Glipizide (กลิพิไซด์)",
  "Gliclazide (กลิคลาไซด์)",
  // ยาความดันโลหิต (Antihypertensives)
  "Amlodipine (แอมโลดิพีน)",
  "Atenolol (อะทีโนลอล)",
  "Losartan (โลซาร์แทน)",
  "Enalapril (เอนาลาพริล)",
  "Nifedipine (นิเฟดิพีน)",
  // ยาต้านการสูญเสียมวลกระดูก (Bisphosphonates)
  "Bisphosphonates (บิสฟอสโฟเนต)",
  "Alendronate (อะเลนโดรเนต)",
  "Zoledronic acid (โซเลดรอนิก แอซิด)",
  // ยาแก้ปวด/ลดอักเสบ (Pain relievers/NSAIDs)
  "Ibuprofen (ไอบูโพรเฟน)",
  "Paracetamol (พาราเซตามอล)",
  "Diclofenac (ไดโคลฟีแนค)",
  "Naproxen (นาพรอกเซน)",
  // ยาปฏิชีวนะ (Antibiotics)
  "Amoxicillin (อะม็อกซีซิลลิน)",
  "Clindamycin (คลินดามัยซิน)",
  "Metronidazole (เมโทรนิดาโซล)",
  "Azithromycin (อะซิโทรมัยซิน)",
  // ยาสเตียรอยด์ (Steroids)
  "Prednisolone (เพรดนิโซโลน)",
  "Dexamethasone (เด็กซาเมทาโซน)",
  // ยาอื่นๆ
  "Levothyroxine (ลีโวไทร็อกซีน)",
  "Simvastatin (ซิมวาสแทติน)",
  "Omeprazole (โอเมพราโซล)",
];
